<template>
  <div v-loading="loading" class="app-container">
    <div>
      <label style="margin-right:10px">{{ $t('common.domain') }}</label>
      <el-select
        v-model="selectedDomainID"
        :disabled="loading"
        class="search-select"
        type="select"
        style="width: 20%; padding-bottom: 10px"
        :placeholder="$t('common.domain')"
      >
        <el-option v-for="domain in domains" :key="domain.id" :label="domain.name" :value="domain.id" />
      </el-select>
    </div>
    <div style="margin-bottom:10px">
      <label style="padding-right:10px">{{ $t('common.year') }}</label>
      <el-date-picker
        v-model="selectedYear"
        :disabled="loading"
        type="year"
        :clearable="false"
        value-format="yyyy"
        :placeholder="$t('common.year')"
      />
    </div>
    <div>
      <label style="margin-right:10px">{{ $t('common.workshop') }}</label>
      <el-select
        v-model="selectedWorkshopID"
        :clearable="true"
        class="search-select"
        type="select"
        style="margin-bottom: 10px"
        :placeholder="$t('common.workshop')"
      >
        <el-option v-for="workshop in workshops" :key="workshop.id" :label="workshop.name" :value="workshop.id" />
      </el-select>
    </div>
    <editor-button
      :disabled="!canDownload() || loading"
      button-translation="report.export"
      action="primary"
      :icon-only="false"
      style="padding-bottom:10px;"
      @click="download()"
    />
  </div>
</template>

<script>
import EditorButton from '@/components/crud/EditorButton';
import { ForceFileDownload } from '@/utils/general';
import { getTimestamp } from '@/utils/util';

export default {
  components: {
    EditorButton
  },
  data() {
    return {
      loading: false,
      selectedDomainID: this.$store.getters['domain/getDefaultSelectValueDomainID'],
      selectedWorkshopID: null,
      selectedYear: new Date().getFullYear().toString()
    };
  },
  computed: {
    domains() {
      return this.$store.getters.domains;
    },
    workshops() {
      return this.$store.getters.workshops;
    }
  },
  methods: {
    canDownload() {
      return this.selectedDomainID !== null && this.selectedYear !== null;
    },
    getDomainName() {
      const id = this.selectedDomainID;
      const domain = this.domains.find(item => item.id === +id);
      return domain && domain.name;
    },
    getWorkshopName() {
      const id = this.selectedWorkshopID;
      if (!id) {
        return '';
      }
      const workshop = this.workshops.find(item => item.id === +id);
      return workshop && workshop.name;
    },
    download() {
      this.loading = true;
      this.$store
        .dispatch('report/clientSalesReport', {
          domainID: this.selectedDomainID,
          year: this.selectedYear,
          workshopID: this.selectedWorkshopID
        })
        .then(blob => {
          const timestamp = getTimestamp();
          let workshopName = this.getWorkshopName();
          if (workshopName) {
            workshopName = ' ' + workshopName;
          }
          const fileName = `${this.selectedYear} Omzetlijst ${this.getDomainName()}${workshopName} ${timestamp}.xlsx`;
          ForceFileDownload(blob, fileName);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
